import { authService } from "@/services/authService";

/**
 * True when sharing must be hidden: the session came from an LTI launch, or
 * the instance is LTI-protected. With no publication mode yet, decides by the
 * session alone.
 */
export const isLtiExperience = (
  publicationMode: string | null | undefined
): boolean => {
  const isLtiSession = authService.getToken()?.authOrigin === "lti";
  return isLtiSession || publicationMode === "LtiProtected";
};
